import styled from "styled-components";

export const Container = styled.tr`

    cursor: pointer;
    &:hover {
        opacity: 0.7;
    }

`;